import React from 'react';
import classnames from 'classnames';

export const List = ({className, ...props}) => <ul className={classnames('DocsList', className)} {...props} />;
